/*!

=========================================================
* CradleAI - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/


const CommonHeader = () => {
  return (
    <>
      <div
        className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
        style={{
          minHeight: "100px",
          backgroundImage:
            "url(" + require("../../assets/img/theme/areatrekbg.jpg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "center center",
        }}
      >
        
      </div>
    </>
  );
};

export default CommonHeader;
